import { JOB_UPDATE_INPUT } from '../../../store/jobs.module';

export default {
  model: {
    // Since we use 'value' property for the state value, components that want to work with v-model also,
    // must use 'boundValue'
    prop: 'boundValue',
  },
  props: {
    type: String,
    readonly: Boolean,
    jobId: String,
    inputName: String,
    boundValue: {
      default: undefined,
    },
  },
  computed: {
    value() {
      return this.$store.getters.jobInputValue(this.jobId, this.inputName);
    },
    passedValue() {
      return this.inputName === undefined || this.inputName === null
        ? this.boundValue
        : this.value;
    },
    validationRules() {
      return this.type == 'required' ? { required: true } : {};
    },
  },
  methods: {
    commitOrEmit(data, enableEdit = false) {
      if (this.inputName === undefined || this.inputName === null) {
        this.$emit('input', data);
      } else {
        this.commitValue(data, enableEdit);
      }
    },
    commitValue(data, enableEdit = false) {
      return this.$store.dispatch(JOB_UPDATE_INPUT, {
        jobId: this.jobId,
        inputName: this.inputName,
        data,
        ...(enableEdit ? { edit: true } : null),
      });
    },
  },
};
